/* eslint-disable import/prefer-default-export */
// See URLSearchParams API here: https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
import { checkIfWidget } from '.';

const getWidgetPathname = () => {
  const { pathname, hash } = window.location;
  const widgetPathname = /[^#?]+/; // extracts the pathname-equivalent value from the hash and drops any params
  return checkIfWidget() ? `${pathname}#${widgetPathname.exec(hash)}` : null;
};

const getURLSearchParams = () => {
  let params = window.location.search;
  const { hash } = window.location;
  if (checkIfWidget()) {
    [, params = ''] = hash.split('?');
  }
  return new URLSearchParams(params);
};

const setSearchParams = (paramKey, paramValue) => {
  const params = getURLSearchParams();
  const { pathname, hash } = window.location;
  const normalizedPathname = checkIfWidget() ? getWidgetPathname() : pathname;
  if (paramValue === null) {
    params.delete(paramKey);
  } else {
    params.set(paramKey, paramValue);
  }
  let path = '';
  let paramsString = params.toString();
  paramsString = paramsString ? `?${paramsString}` : paramsString;
  if (checkIfWidget() || !hash) {
    path = `${normalizedPathname}${paramsString}`;
  } else {
    path = `${normalizedPathname}${paramsString}${hash}`;
  }

  window.history.replaceState({}, '', path);
};

export { getURLSearchParams, setSearchParams };
